import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWorkExperience } from "../../redux/actions/workExpActions";
import Table from './Table'
import FormAdd from './FormAdd'
import { useTranslation } from "react-i18next";

export default function WorkExperience() {
   const dispatch = useDispatch();
   const wexp = useSelector((state) => state.workExpReducers);
   const [showFormAdd, setShowFormAdd] = useState(false);
   const { t } = useTranslation('common');

   useEffect(() => {
      if (!wexp.loaded) dispatch(getWorkExperience());
   }, [dispatch, wexp.loaded]);

   const openFormAdd = () => {
      setShowFormAdd(!showFormAdd);
      dispatch({ type: "WE_SUCCESS_OFF" });
      dispatch({ type: 'WE_ERROR_OFF' })
   };

   const closeFormAdd = () => {
      setShowFormAdd(false);
      dispatch({ type: "WE_SUCCESS_OFF" });
      dispatch({ type: 'WE_ERROR_OFF' })
   };

   return (
      <>
         <div className="flex-col flex-1 w-full h-full pb-16 overflow-y-auto container grid px-6 mx-auto">
            <h1 className="mt-10 text-2xl font-semibold font-poppins text-black dark:text-gray-200">{t('experience.title')}</h1>
            <div className="flex justify-between items-end mb-4">
               <h4 className="mt-2 mb-3 font-poppins lg:text-sm text-xs inline-block">{t('experience.experience_description')}</h4>
            </div>
            <div>
               <button
                  className="flex items-center justify-between py-2 px-4 my-4 text-sm font-medium leading-5 text-gray-700 font-poppins hover:text-white bg-gray-200 transition-colors duration-150 border-2 border-gray-700  border-transparent rounded-md active:bg-red-600 hover:bg-gray-600 focus:outline-none focus:shadow-outline-black float-right" 
                  onClick={openFormAdd}
               >
                  <i
                     className={`fa ${showFormAdd ? "fa-times" : "fa-folder-plus"
                        } fa-1x mr-2`}
                  ></i>{" "}
                  {showFormAdd ? t('experience.close') : t('experience.add')}
               </button>
            </div>
            <FormAdd
               status={showFormAdd}
               closeFormAdd={closeFormAdd}
            />
            {!showFormAdd && <Table /> }
         </div>
      </>
   );
}
